import React, { createContext, useContext, useEffect, useState } from "react";

// Iter 18 — Theme system
// Stored under `bt_theme` (separate from `bt_prefs` so neither overwrites the
// other). On first visit we read `prefers-color-scheme`. The class is applied
// to <html> so CSS variables in index.css flip the entire palette in one go.
const ThemeContext = createContext({ theme: "dark", toggleTheme: () => {}, setTheme: () => {} });

const STORAGE_KEY = "bt_theme";

function getInitialTheme() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === "dark" || saved === "light") return saved;
  } catch { /* private mode → fall through */ }
  if (typeof window !== "undefined" && window.matchMedia) {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  return "dark";
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(getInitialTheme);

  // Sync the <html> class so all CSS vars flip immediately.
  useEffect(() => {
    const html = document.documentElement;
    html.classList.remove("dark", "light");
    html.classList.add(theme);
    try { localStorage.setItem(STORAGE_KEY, theme); } catch { /* noop */ }
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === "dark" ? "light" : "dark"));
  // Iter 52 — expose direct setter for the consolidated account dropdown
  // so it can switch to a specific theme value (e.g. via segmented control).
  const setThemeSafe = (next) => {
    if (next === "dark" || next === "light") setTheme(next);
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, setTheme: setThemeSafe }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
